<div>
  <span class="headline">Nombre de demandes envoyées</span>
  <app-demands-statistics-loader [isLoading]="isLoading"></app-demands-statistics-loader>
  <div *ngIf="!isLoading" align="center" class="chart-demands-envoyees" [chart]="chart"></div>
</div>
